module.exports = __webpack_public_path__ + "static/media/P2_Micropipette.c6106709.svg";